import React from "react";
import type { components } from "../types/api";
import EuroIcon from "@mui/icons-material/Euro";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import CurrencyYenIcon from "@mui/icons-material/CurrencyYen";
import CurrencyFrancIcon from "@mui/icons-material/CurrencyFranc";
import CurrencyLiraIcon from "@mui/icons-material/CurrencyLira";
import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CurrencyYuanIcon from "@mui/icons-material/CurrencyYuan";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

export const getCurrencyIcon = (
  currencyCode?: string | null,
  fontSize: "small" | "medium" | "large" | "inherit" = "small"
) => {
  if (!currencyCode) return <AccountBalanceWalletIcon fontSize={fontSize} />;

  const code = currencyCode.toUpperCase();

  switch (code) {
    case "EUR":
      return <EuroIcon fontSize={fontSize} />;
    case "USD":
    case "CAD":
    case "AUD":
    case "MXN":
    case "ARS":
    case "CLP":
    case "COP":
    case "BRL":
      return <AttachMoneyIcon fontSize={fontSize} />;
    case "GBP":
      return <CurrencyPoundIcon fontSize={fontSize} />;
    case "JPY":
      return <CurrencyYenIcon fontSize={fontSize} />;
    case "CNY":
    case "RMB":
      return <CurrencyYuanIcon fontSize={fontSize} />;
    case "CHF":
      return <CurrencyFrancIcon fontSize={fontSize} />;
    case "TRY":
      return <CurrencyLiraIcon fontSize={fontSize} />;
    case "RUB":
      return <CurrencyRubleIcon fontSize={fontSize} />;
    case "INR":
      return <CurrencyRupeeIcon fontSize={fontSize} />;
    default:
      return <AccountBalanceWalletIcon fontSize={fontSize} />;
  }
};

/**
 * Returns the currency symbol for a given currency enum
 * @param currency_enum - The currency enum from Prisma
 * @returns The corresponding currency symbol
 */
export const getCurrencySymbol = (
  currency_enum: components["schemas"]["currency"] | string
): string => {
  switch (currency_enum) {
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    case "JPY":
      return "¥";
    case "CHF":
      return "CHF";
    case "CNY":
    case "RMB":
      return "¥";
    case "USD":
    default:
      return "€";
  }
};

/**
 * Returns the currency code for a given currency enum
 * @param currency_enum - The currency enum from Prisma
 * @returns The corresponding currency code
 */
export const getCurrencyCode = (
  currency_enum: components["schemas"]["currency"]
): string => {
  return currency_enum;
};
